import { Button } from "@mantine/core";
import { useState } from "react";
import type { WizardMissingData } from "../../../../../utils/backend-types";
import { MissingDataActionButton } from "../../../components/MissingDataActionButton";
import { AssignmentType } from "../../OnboardingWizard.constants";
import "./ConfigurationAssignment.scss";
import { ConfigurationConfirmationModal } from "./ConfigurationConfirmationModal/ConfigurationConfirmationModal";

type ConfigurationAssignmentProps = {
  done: boolean;
  missingData: Array<WizardMissingData>;
  siteId: number;
  projectId?: string;
  updateSiteWizard: (type: AssignmentType) => Promise<void>;
};

function ConfigurationAssignment({
  done,
  missingData,
  siteId,
  projectId,
  updateSiteWizard
}: ConfigurationAssignmentProps) {
  const [isSpinning, setIsSpinning] = useState(false);
  const hasMissingData = missingData && missingData.length > 0;
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  function onClickSubmit() {
    setShowConfirmationModal(false);
    setIsSpinning(true);
    updateSiteWizard(AssignmentType.Configuration).then(() => {
      setIsSpinning(false);
    });
  }
  function openConfirmationModal() {
    setShowConfirmationModal(true);
  }

  function getComponentByStep() {
    if (hasMissingData && !done) {
      return <MissingDataActionButton mt="xs" route="konfiguration" />;
    } else if (!done) {
      return (
        <div className="missing-data-container">
          <Button
            className="missing-data-button"
            color="primary"
            loading={isSpinning}
            variant={"default"}
            onClick={() => openConfirmationModal()}
          >
            Konfiguration bestätigen
          </Button>
        </div>
      );
    }
  }

  return (
    <div className="ConfigurationAssignment">
      {showConfirmationModal && (
        <ConfigurationConfirmationModal
          projectId={projectId}
          siteId={siteId}
          onCancel={() => setShowConfirmationModal(false)}
          onConfirm={() => onClickSubmit()}
        />
      )}
      {getComponentByStep()}
    </div>
  );
}

export { ConfigurationAssignment };
